import { FC, ReactNode } from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { ControlSection } from '../ui/ControlSection';

interface CanvasControlButtonGroupProps {
  title: string;
  value: string;
  onChange: (value: string) => void;
  options: {
    value: string;
    label: ReactNode;
  }[];
}

export const CanvasControlButtonGroup: FC<CanvasControlButtonGroupProps> = ({
  title,
  value,
  onChange,
  options,
}) => {
  return (
    <ControlSection title={title}>
      <ButtonGroup variant='outlined' size='small' fullWidth>
        {options.map((option) => (
          <Button
            key={option.value}
            onClick={() => onChange(option.value)}
            variant={value === option.value ? 'toggleActive' : 'toggleInactive'}
            sx={{
              fontSize: '11px',
              fontWeight: 600,
              justifyContent: 'center',
              gap: '4px',
            }}
          >
            {option.label}
          </Button>
        ))}
      </ButtonGroup>
    </ControlSection>
  );
};
